<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm12 md10 lg8>
            <v-card class="elevation-12">
              <v-toolbar dark color="#333333" height="185px">
                <div style="margin-top: 25px; margin-bottom: 15px;">
                  <img src="static/logo.png">
                </div>
                <v-toolbar-title>
                  {{ $t($config.title) }} {{ localizedDate }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <v-btn icon large target="_blank" slot="activator" @click="setLangNl">
                    <div style="font-size:20px"  >
                      <flag iso="nl" :squared="false" />
                    </div>
                  </v-btn>
                  <span>Nederlands</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    large
                    target="_blank"
                    slot="activator"
                    @click="setLangEn"
                  >
                    <div style="font-size:20px">
                      <flag iso="gb" :squared="false" />
                    </div>

                    <!--<v-icon large>code</v-icon>-->
                  </v-btn>
                  <span>English</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn icon large target="_blank" slot="activator" @click="setLangDe">
                    <div style="font-size:20px">
                      <flag iso="de" :squared="false" />
                    </div>
                  </v-btn>
                  <span>Deutsch</span>
                </v-tooltip>
              </v-toolbar>
              <v-card-text>
                  <form-component :lang="language"></form-component>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Vuetify from 'vuetify';
import FlagIcon from 'vue-flag-icon';
import 'vuetify/dist/vuetify.min.css';
import messages from './translations.json';
import FormComponent from './components/FormComponent';

function getLanguage() {
  const lang = window.localStorage.getItem('language');
  const validValues = ['nl', 'en', 'de'];
  if (!lang || validValues.indexOf(lang) < 0) {
    return 'nl';
  }
  return lang;
}

function setLanguage(lang) {
  window.localStorage.setItem('language', lang);
  location.reload();
}

Vue.use(VueI18n);
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: getLanguage(), // set locale
  messages, // set locale messages
});
Vue.use(FlagIcon);
Vue.use(Vuetify);

// change missing handler
i18n.missing = (locale, key, vm) => {
  let store = JSON.parse(window.localStorage.getItem('missing-translation')) || {};
  if (!store) {
    store = {};
  }
  const name = vm.$options.name;
  if (!(store[name])) {
    store[name] = {};
  }
  if (!store[name][locale]) {
    store[name][locale] = {};
  }
  if (!store[name][locale].messages) {
    store[name][locale].messages = {};
  }
  store[name][locale].messages[key] = key;
  window.localStorage.setItem('missing-translation', JSON.stringify(store));
};


export default {
  name: 'App',
  i18n,
  components: { FormComponent },
  data() {
    return {
      language: getLanguage(),
    };
  },
  computed: {
    localizedDate() {
      const date = new Date(this.$config.date);
      const dateTo = new Date(this.$config.dateEnd);
      let dayFormat = '';
      let locale = 'nl-NL';

      if (!this.$config.isBriardWeekend) {
        return `${date.toLocaleString(locale, { day: 'numeric', year: 'numeric', month: 'long' })}`;
      }

      if (this.language === 'de') {
        locale = 'de-DE';
        dayFormat = `am ${date.toLocaleString(locale, { day: 'numeric' })} und ${dateTo.toLocaleString(locale, { day: 'numeric' })}`;
      } else if (this.language === 'en') {
        locale = 'en-GB';
        dayFormat = `${date.toLocaleString(locale, { day: 'numeric' })} and ${dateTo.toLocaleString(locale, { day: 'numeric' })}`;
      } else {
        dayFormat = `${date.toLocaleString(locale, { day: 'numeric' })} en ${dateTo.toLocaleString(locale, { day: 'numeric' })}`;
      }
      return `${dayFormat} ${date.toLocaleString(locale, { year: 'numeric', month: 'long' })}`;
    },
  },
  methods: {
    setLangNl() {
      setLanguage('nl');
    },
    setLangEn() {
      setLanguage('en');
    },
    setLangDe() {
      setLanguage('de');
    },
  },
};
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  .v-toolbar__title {
    text-overflow: initial;
    white-space: initial;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue